export default __webpack_public_path__ + "static/media/horario.3ff2f668.svg";